import React, { Component } from "react";
import { connect } from "react-redux";
import { createState } from "../../../actions/masters/stateActions";
import { Link } from "react-router-dom";
import StateForm from "./StateForm";
import history from "../../../history";

class StateCreate extends Component {
  onSubmit = (formValues) => {
    this.props.createState(this.props.match.params.id, formValues);
  };

  render() {
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Add a State</h3>
          </div>
          <div className="float-end mt-15">
            <Link
              className="float-end cardBackBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </Link>
          </div>
        </div>
        <StateForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
export default connect(null, { createState })(StateCreate);
